// extracted by mini-css-extract-plugin
export default {"formWrap":"Search_formWrap__INcBM","left":"Search_left__lsWp7","right":"Search_right__obY-4"};